import { Injectable } from '@angular/core';
import { ApiRequestService } from '@app/core/http/api-request.service';
import { of, Observable } from 'rxjs';
import { COLUMNS, TABLEDATA } from './data';

@Injectable({
  providedIn: 'root'
})
export class DashboardListService {
  public columns = COLUMNS;
  public data = TABLEDATA;
  constructor(private apiService: ApiRequestService) {}

  getHeader(url: string, period: string = 'yesterday'): Observable<any[]> {
    return url ? of(this.columns[url]) : of([]);
  }
  getData(url: string, period: string = 'yesterday'): Observable<any[]> {
    return url ? of(this.data[url]) : of([]);
  }
}
